<template>
    <v-select
        :items="selectOptions"
        :loading="isLoading"
        @change="emitSelected"
        clearable
        item-text="text"
        item-value="value"
        label="Filter"
        v-model="selectedOption"
    ></v-select>
</template>
<script>
export default {
    mounted: function() {
        //
    },
    created: async function() {
        let areas = await this.$store.dispatch("areas/getUserAreasList");
        let providers = await this.$store.dispatch(
            "providers/getUserProvidersList"
        );

        if (areas.length > 0) {
            this.selectOptions.push({
                header: "Areas"
            });
            areas.forEach(x =>
                this.selectOptions.push({
                    text: x.value,
                    value: { providerId: 0, areaId: x.key }
                })
            );
        }
        if (providers.length > 0) {
            this.selectOptions.push({
                header: "Providers"
            });

            providers.forEach(x =>
                this.selectOptions.push({
                    text: x.value,
                    value: { providerId: x.key, areaId: 0 }
                })
            );
        }
        this.isLoading = false;
    },
    components: {
        //
    },
    props: [],
    data() {
        return {
            selectOptions: [
                /*
                { text: "None", value: { providerId: 0, areaId: 0 } },
                {
                    text: "Areas",
                    value: { providerId: 0, areaId: 0 },
                    disabled: true
                },
                { text: "AreasA", value: { providerId: 0, areaId: 1 } },
                { text: "AreasB", value: { providerId: 0, areaId: 2 } },
                {
                    text: "Providers",
                    value: { providerId: 0, areaId: 0 },
                    disabled: true
                },
                { text: "Provider1", value: { providerId: 1, areaId: 0 } },
                { text: "Provider2", value: { providerId: 2, areaId: 0 } }
            */
            ],
            selectedOption: null,
            isLoading: true
        };
    },
    methods: {
        emitSelected() {
            this.$emit(
                "selection-changed",
                this.selectedOption == null
                    ? { providerId: 0, areaId: 0 }
                    : this.selectedOption
            );
        }
    }
};
</script>

<style lang="stylus" scoped></style>